import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconArrowDownChevronSmall.tsx
const IconArrowDownChevronSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m12 15-4.242-4.243 1.415-1.414L12 12.172l2.828-2.829 1.415 1.414z"
	})]
});
var IconArrowDownChevronSmall_default = forwardRef(IconArrowDownChevronSmall);
//#endregion
export { IconArrowDownChevronSmall_default as default };
